import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MentionService {

  /**
   * Converts @mentions in text into hyperlink format.
   */
  formatMentions(text: string, mentionMap: Map<string, number>): string {
    if (!text) return '';
  
    const mentionRegex = /@([\w+.-]+)/g;
  
    return text.replace(mentionRegex, (_: string, nickname: string) => {
      const userId = mentionMap.get(nickname);
      if (userId !== undefined) {
        return `<a href="/account/profile/${userId}" class="mention-link">@${nickname}</a>`;
      } else {
        console.warn(`Mention not found in map: ${nickname}`);
        return `@${nickname}`;
      }
    });
  }
  

  /**
   * Converts mention links back to plain text (@nickname format).
   */
  stripMentions(text: string): string {
    if (!text) return '';

    const mentionRegex = /<a[^>]*>(@[^<]+)<\/a>/g;
    return text.replace(mentionRegex, '$1');
  }
}